import { 
    createSlice, 
    createAsyncThunk,  
    createEntityAdapter,  
} from '@reduxjs/toolkit'
import { Pager } from '../../../lib/js-apiclient/src/response/Pager';
import { WooCommerceModel } from '../models/woocommerce/WooCommerceModel';


const wooCommerceCategoryAdapter = createEntityAdapter({})

export const wooCommerceCategoryApi = {
    _model: null,
    _getToken: (thunkAPI) => {
        return thunkAPI.getState().identityReducer.token.signature;
    },
    fetchAll: createAsyncThunk(
        'woocommerce/category/fetchAll', 
        async ({channelId, page, term, parentId}, thunkAPI) => {
            try {
                const token = wooCommerceCategoryApi._getToken(thunkAPI);
                const wchModel = new WooCommerceModel(token, channelId, parentId);

                /** @type {Pager} */
                const pager = await wchModel.getCategories(page, term);
                
                return {
                    hasPrevPage: pager.hasPrevPage,
                    hasNextPage: pager.hasNextPage,
                    entities: pager.getEntities()
                }
            } catch (apiError) {
                return thunkAPI.rejectWithValue(apiError.toJson());
            }
        }
    ),
}

const wooCommerceCategorySlice = createSlice({
    name: "woocommerce/category",
    initialState: wooCommerceCategoryAdapter.getInitialState({
        status: 'idle',
        error: null,
        showMore: true,
    }),
    reducers: {
        clearCategoryList(state, action) {
            wooCommerceCategoryAdapter.removeAll(state);
        },
    },
    extraReducers: {
        [wooCommerceCategoryApi.fetchAll.fulfilled]: (state, action) => {
            state.status = 'woocommerce/category/fetchAll/succeeded'

            if(action.payload.hasPrevPage) {
                wooCommerceCategoryAdapter.addMany(state, action.payload.entities)
            } else {
                wooCommerceCategoryAdapter.setAll(state, action.payload.entities)
            }

            state.showMore = action.payload.hasNextPage;
            state.error = null;
        },
        [wooCommerceCategoryApi.fetchAll.rejected]: (state, action) => {
            state.status = 'woocommerce/category/fetchAll/rejected'
            state.error = action.payload
        },
    }
});

export const {
    selectAll: selectAllWooCommerceCategories,
} = wooCommerceCategoryAdapter.getSelectors((state) => state.wooCommerceCategoryReducer)

export const { clearCategoryList } = wooCommerceCategorySlice.actions;

export default wooCommerceCategorySlice.reducer;
